import { serviceRequest } from 'utils/http';
import { ProtocolInfoDto, ReferralService } from 'common/api';

type UpdateReferralProtocol = {
  referralId: string;
  protocol: ProtocolInfoDto;
};

export function updateReferralProtocolAPI({
  referralId,
  protocol,
}: UpdateReferralProtocol) {
  return serviceRequest(() =>
    ReferralService.referralControllerUpdateCurrentUserProtocol(
      referralId,
      protocol
    )
  );
}
